import { gql } from '@apollo/client';

const CREATE_SHIPMENT = gql`
  mutation createShipment($input: [CreateShipmentInput]!) {
    createShipment(input: $input) {
     shipmentIds
     deliveryPartners
    }
  }
`;

// ADD THIS NEW MUTATION
const CREATE_RETURN_SHIPMENT = gql`
  mutation createReturnShipment($input: CreateReturnShipmentInput!) {
    createReturnShipment(input: $input) {
      returnShipmentId
      success
      message
    }
  }
`;

const GET_RETURN_SHIPMENTS_BY_ORDER_ID = gql`
  query GetReturnShipmentsByOrderId($orderId: Int!) {
    getReturnShipmentsByOrderId(orderId: $orderId) {
      _id
      return_shipment_id
      order_id
      return_type
      contact
      notes
      products {
        product_id
        original_shipment_id
        original_shipment_index
      }
      delivery_partner
      order_type
      service_type
      floor
      lift
      created_at
      updated_at
    }
  }
`

const RETRY_SHIPMENT_CSV = gql`
  mutation retryShipmentCSV($shipment_id: Int!) {
    retryShipmentCSV(shipment_id: $shipment_id) {
      success
      message
    }
  }
`

export {
    CREATE_SHIPMENT,
    CREATE_RETURN_SHIPMENT,
    GET_RETURN_SHIPMENTS_BY_ORDER_ID,
    RETRY_SHIPMENT_CSV
}
